@if (headerInfo(); as headerInfo) {
  <div class="govuk-phase-banner">
    <p class="govuk-phase-banner__content">
      <span class="govuk-!-font-weight-bold" data-testId="name">{{ headerInfo.name }}</span>
      <span class="govuk-!-padding-left-3 govuk-!-font-weight-bold" data-testId="businessId">{{
        headerInfo.businessId
      }}</span>

      @if (headerInfo.status) {
        <span class="govuk-!-padding-left-3" data-testId="status">{{ 'Status: ' + headerInfo.status }}</span>
      }
    </p>
  </div>
}
